module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1507-b7c69ba32e721d2cc55fe06a78424fb3.png";